import { memo } from 'react';
import { useTranslation } from 'next-i18next';

import styles from './ProductFitSentiment.module.scss';

export interface FitSentimentFlyOutProps {
  runsSmall: number;
  trueToSize: number;
  runsLarge: number;
  total: number;
}
export const FitSentimentFlyOut = ({
  runsSmall,
  trueToSize,
  runsLarge,
  total,
}: FitSentimentFlyOutProps) => {
  const { t } = useTranslation('pdp');

  const sizingMessage = (amount: number, size: string) =>
    amount > 0 ? (
      <li key={size}>
        {amount}% {t(`product.fitSentiment.flyOut.${size}`)}
      </li>
    ) : null;
  const sizes = { runsSmall, trueToSize, runsLarge };

  return (
    <>
      <ul className={styles.flyOutList}>
        {Object.entries(sizes).map(([size, amount]) =>
          sizingMessage(amount, size)
        )}
        <li className={styles.flyOutSubText}>
          {total > 1
            ? `${t('product.fitSentiment.flyOut.basedOn')} ${total} ${t(
                'product.fitSentiment.flyOut.reviews'
              )}`
            : `${t('product.fitSentiment.flyOut.basedOn')} ${total} ${t(
                'product.fitSentiment.flyOut.review'
              )}`}
        </li>
      </ul>
    </>
  );
};

export default memo(FitSentimentFlyOut);
